<template>
    <div id="menuBar">
        <div class="menu-leftbar" :class="{w50:isCollapse}">
            <el-menu :default-active="$route.path" :default-opened="$route.path" @open="handleOpen" @close="handleClose" :collapse="isCollapse" :unique-opened="false">
                
                <el-submenu index="/baseArchives" class="menu1" v-authority="{code:101,mode:'none'}">
                    <template slot="title">
                        <i class="el-icon-location"></i>
                        <span slot="title">基础档案</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/organize" @click="handleUrl('/baseArchives.html#/organize')" v-authority="{code:101101,mode:'none'}">组织信息</el-menu-item>
                        <el-menu-item index="/account" @click="handleUrl('/baseArchives.html#/account')" v-authority="{code:101102,mode:'none'}">账户档案</el-menu-item>
                        <el-menu-item index="/settlement" @click="handleUrl('/baseArchives.html#/settlement')" v-authority="{code:101103,mode:'none'}">结算方式</el-menu-item>
                        <el-menu-item index="/init" @click="handleUrl('/baseArchives.html#/init')" v-authority="{code:101104,mode:'none'}">账户初始化</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="/clearManage" class="menu2" v-authority="{code:103,mode:'none'}">
                    <template slot="title">
                        <i class="el-icon-location"></i>
                        <span slot="title">清算管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/adjustBill" @click="handleUrl('/clearManage.html#/adjustBill')" v-authority="{code:103101,mode:'none'}">调整单</el-menu-item>
                        <el-menu-item index="/applyBill" @click="handleUrl('/clearManage.html#/applyBill')" v-authority="{code:103102,mode:'none'}">对账单申请</el-menu-item>
                        <el-menu-item index="/bill" @click="handleUrl('/clearManage.html#/bill')" v-authority="{code:103103,mode:'none'}">对账单</el-menu-item>
                        <el-menu-item index="/clearBill" @click="handleUrl('/clearManage.html#/clearBill')" v-authority="{code:103104,mode:'none'}">清算单</el-menu-item>
                        <el-menu-item index="/collectBail" @click="handleUrl('/clearManage.html#/collectBail')" v-authority="{code:103105,mode:'none'}">保证金管理</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                
                <el-menu-item index="/home" class=""  @click="handleUrl('/home.html#/home')">
                    <template slot="title">
                        <i class="el-icon-picture-outline"></i>
                        <span slot="title">首页</span>
                    </template>
                </el-menu-item>
                <el-submenu index="/system" class="menu6">
                    <template slot="title">
                        <i class="el-icon-location"></i>
                        <span slot="title">系统管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/sysuser" @click="handleUrl('/system.html#/sysuser')">系统用户管理</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
            <div class="menuTab">
                <div class="menuTabBtn" @click="changeMenu" :class={rotate:isCollapse}>
                    <span></span>
                    <span class="long"></span>
                    <span></span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'platfrom',
    data () {
        return {
            isCollapse: false,
            baseUrl: ''
        }
    },
    mounted () {
        // var self = this
        // if (
        //     '-ms-scroll-limit' in document.documentElement.style &&
        //     '-ms-ime-align' in document.documentElement.style
        // ) {
        //     // detect it's IE11
        //     window.addEventListener(
        //         'hashchange',
        //         function (event) {
        //             var currentPath = window.location.hash.slice(1)
        //             // if (store.state.route.path !== currentPath) {
        //             self.$router.push(currentPath)
        //             // }
        //         },
        //         false
        //     )
        // }
        function checkIE(){
            return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
            }
            if (checkIE()) {
            window.addEventListener('hashchange', () => {
                var currentPath = window.location.hash.slice(1);
                if (this.$route.path !== currentPath) {
                this.$router.push(currentPath)
            }
            }, false)
            }
  
    },
    methods: {
        handleOpen (key, keyPath) {
            // window.location.href = key;
            // console.log(key, keyPath)
            this.baseUrl = keyPath[0]
        },
        handleClose (key, keyPath) {
            // console.log(key, keyPath)
        },
        handleUrl (url) {
            window.location.href = url
        },
        changeMenu () {
            this.isCollapse = !this.isCollapse
            this.$emit('checkMenu', this.isCollapse)
        }
    },
    watch: {
        $route () {
            // console.log(this.$route.path);
        }
    }
}
</script>
<style>
.menu-leftbar {
    width: 210px;
    background: rgba(255, 255, 255, 1);
    height: 100%;
    border-radius: 4px 0px 0px 4px;
    position: absolute;
    left: 0;
    top: 0;
    padding: 64px 0 56px;
    box-sizing: border-box;
    overflow: hidden;
    transition: all 0.3s ease-in;
}

.w50 {
    width: 50px;
}

.menu-leftbar .el-menu--collapse {
    width: 100%;
    border: 0;
}

.menu-leftbar .el-menu--collapse .el-submenu__title {
    padding: 0 !important;
}

.el-menu--popup {
    padding: 0;
}

.el-menu-item-group .el-menu-item-group__title {
    padding: 0;
    line-height: 50px;
}

.menu-leftbar .el-menu {
    border: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
}

.menu-leftbar .el-menu--collapse .el-submenu__title i {
    width: 80px;
    height: 50px;
    position: relative;
    display: block;
    background-position: center center;
    background-repeat: no-repeat;
    margin: 20px 0 0 0;
    text-indent: -999em;
}

.el-menu-item,
.el-submenu__title {
    height: 50px;
    line-height: 50px;
}

.el-submenu [class^='el-icon-'] {
    width: 17px;
    height: 17px;
    background-repeat: no-repeat;
    display: inline-block;
}

.menu1 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu1.png');
}

.menu2 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu2.png');
}

.menu3 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu3.png');
}

.menu4 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu4.png');
}

.menu5 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu5.png');
}

.menu6 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu6.png');
}
.menu7 [class^='el-icon-'] {
    background-image: url('../assets/icon_menu7.png');
}

.el-icon-location:before {
    display: none;
}

.el-menu--collapse > .el-menu-item [class^='el-icon-'],
.el-menu--collapse > .el-submenu > .el-submenu__title [class^='el-icon-'] {
    width: 50px;
}

/* .el-submenu .subTitle::before,
	.el-menu-item-group .el-menu-item::before {
		content: '';
		width: 4px;
		height: 4px;
		background: #606266;
		display: inline-block;
		border-radius: 50%;
		left: -10px;
		position: relative;
		vertical-align: middle;
	} */

.el-menu-item-group .el-menu-item.is-active::before {
    background: #1989fa;
}

.el-menu-item.is-active {
    background: linear-gradient(
        -90deg,
        rgba(250, 252, 255, 1),
        rgba(244, 248, 254, 1)
    );
    position: relative;
}

.el-menu-item.is-active::after {
    content: '';
    width: 15px;
    height: 100%;
    background: rgba(25, 137, 250, 1);
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
/* .el-menu--collapse .el-submenu{} */

.el-menu--collapse .is-active {
    background: rgba(25, 137, 250, 0.1);
}

.menuTab {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    background: #fff;
    box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.06);
}

.menuTab .menuTabBtn {
    width: 13px;
    text-align: right;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: rotate(0) translateY(-50%);
    cursor: pointer;
}

.menuTab .menuTabBtn.rotate {
    transform: rotate(180deg) translateY(50%);
}

.menuTab span {
    width: 9px;
    height: 1px;
    background: rgba(25, 137, 250, 1);
    overflow: hidden;
    margin: 3px 0;
    float: right;
}

.menuTab .long {
    width: 13px;
}
</style>
